import request from '@/utils/request'

export function listVarUse(query) {
  return request({
    url: '/server/var/listUse',
    method: 'get',
    params: query
  })
}

// 新增变量引用
export function addVarUse(data) {
  return request({
      url: '/server/var/addUse',
      method: 'post',
      data: data
  });
}
// 修改变量引用
export function editVarUse(data) {
  return request({
      url: '/server/var/editUse',
      method: 'post',
      data: data
  });
}

// 修改变量引用
export function deleteVar(data) {
  return request({
      url: '/server/var/deleteUse/' + data,
      method: 'post',
  });
}

